export default {
  'current_lang': 'Language (EN)',
  'chinese_zh': 'Chinese Simplified',
  'chinese_tw': '繁體中文',
  'english': 'English',
  'general': {
    'list': {
      'display': 'Display',
      'to': 'to',
      'of': 'of',
      'records': 'records',
      'prev': 'Prev',
      'next': 'Next',
    },
    'input': {
      'please_select_status': 'Please select a status',
      'please_select_courier': 'Please select a courier',
      'please_select_a_shipping_method': 'Please select a shipping method',
      'please_select_supplier': 'Please select a supplier',
      'please_select_a_incoterm': 'Please select a incoterm',
      'please_select_courier_service': 'Please select a courier service',
      // 'please_input_sku': 'Please input a SKU',
      // 'please_input_product_name': 'Please input a product name',
      // 'please_input_description_for_export': 'Please input a description for export',
      // 'please_input_description_for_import': 'Please input a description for import',
      // 'please_input_quantity': 'Please input quantity',
    },
    'package': {
      'package': 'Package',
      'plastic_bag': 'PAK 袋',
      'letters': 'Letters',
    },
    'button': {
      'add': 'Add',
      'delete': 'Delete',
      'ok': 'OK',
      'submit': 'Submit',
    },
    'action': 'Action',
    'create': 'create',
    'edit': 'edit',
    'yes': 'Yes',
    'no': 'No',
  },
  'sidebar': {
    'dashboard': 'Dashboard',
    'delivery': 'Delivery',
    'shipment': 'Shipments',
    'label':'Labels',
    'pending_order': 'Pending',
    'delivery_order': 'Delivery',
    'delivery_audit_weight': 'Update Weight',
    'delivery_outbound': 'Shipped',
    'delivery_inbound': 'Ready To Ship',
    'marketplace': 'Marketplace',
    'marketplace_order': 'Marketplace Order',
    'marketplace_store': 'Marketplace Store',
    'marketplace_rma_product': 'RMA Product',
    'marketplace_faq': 'Marketplace FAQ',
    'shipper': 'Shipper',
    'supplier': 'Supplier',
    'supplier_invoice': 'Supplier Invoice',
    'courier': 'Courier',
    'contact_message': 'Tracking Message',
    'comparison_tool': 'Comparison Tool',
    'tracking': 'Tracking Status',
    'marketplace_upload_order_tracking': 'Upload Tracking',
    'marketplace_pending_accept': 'Pending Accepts',
    'marketplace_order_shipment': 'Uploaded Shipments',
    'contact_message_edit': 'Contact Message Edit'
  },
  'breadcrumb': {
    'home': 'Home',
    'dashboard': 'Dashboard',
    'delivery': 'Delivery',
    'pending': 'Pending',
    'pending_order': 'Pending Shipment',
    'inbound_list': 'Inbound Shipments',
    'outbound_list': 'Outbound Shipments',
    'audit_list': 'Audit Shipments',
    'delivery_audit_weight': 'Update Shipment Weight',
    'upload_delivery_audit_weight': 'Upload Audit Weight',
    'not_audit_list': 'Not Audit Shipments',
    'order_create': 'Order Create',
    'order_edit': 'Order Edit',
    'order_show': 'Order Show',
    'order_upload': 'Order Upload',
    'order': 'Order',
    'order_list': 'Order List',
    'order_detail': 'Order Detail',
    'marketplace_order': 'Marketplace Order',
    'marketplace_order_list': 'Marketplace Order List',
    'store': 'Store',
    'store_list': 'Store List',
    'store_create': 'Store Create',
    'store_edit': 'Store Edit',
    'rma_product': 'RMA Product',
    'rma_product_list': 'RMA Product List',
    'rma_product_create': 'RMA Product Create',
    'rma_product_edit': 'RMA Product Edit',
    'faq': 'FAQ',
    'faq_list': 'FAQ List',
    'faq_create': 'FAQ Create',
    'faq_edit': 'FAQ Edit',
    'shipper': 'Shipper',
    'shipper_list': 'Shipper List',
    'shipper_create': 'Shipper Create',
    'shipper_edit': 'Shipper Edit',
    'courier_list': 'Courier List',
    'marketplace': 'Marketplace',
    'track': 'Tracking',
    'track_list': 'Tracking List',
    'upload_marketplace_order_tracking': 'Upload Marketplace Order Tracking',
    'user': 'User',
    'contact_message': 'Contact Message',
    'contact_message_list': 'Contact Message List',
    'update_password': 'Update Password',
    'marketplace_order_shipment': 'Marketplace Order Shipment'
  },
  'delivery': {
    'shipment': {
      'courier': 'Courier',
      'reference_no': 'Reference No.',
      'tracking_no': 'Tracking No.',
      'status': 'Status',
      'courier_name': 'Courier Name',
      'courier_slug': 'Courier Slug',
      'pickup_note': 'Pickup Note',
      'signed_by': 'Signed By',
      'lead_time': 'Lead Time',
      'updated_at': 'Updated At',
      'operation': 'Operation',
      'filter_option': 'Filter Option',
      'shipment_date': 'Shipment Date',
      'please_enter_reference_no': 'Please enter your reference no.',
      'enter_reference_no': 'Enter Reference No..',
      'please_enter_tracking_no': 'Please enter your tracking No.',
      'enter_tracking_no': 'Enter Tracking No.',
      'search': 'Search',
      'reset': 'Reset',
    },
    'label': {
      'sender_info': 'Sender Info',
      'item_details': 'Item Details',
      'pending_order': 'Pending Order',
      'pending': 'Pending',
      'inbound': 'Ready To Ship',
      'outbound': 'Shipped',
      'orders': 'orders',
      'filter_option': 'Filter Option',
      'batch_id': 'Batch ID',
      'enter_batch_id': 'Enter Batch ID...',
      'upload_order_date': 'Order Upload Period',
      'reference_no': 'Reference No.',
      'service_name': 'Courier Service Name',
      'service_code': 'Service Code',
      'please_enter_reference_no': 'Please enter your reference no.',
      'enter_reference_no': 'Enter Reference No..',
      'waybill_number': 'Waybill Number.',
      'tracking_no': 'Tracking No.',
      'please_enter_tracking_no': 'Please enter your tracking No.',
      'enter_tracking_no': 'Enter Tracking No.',
      'please_enter_waybill_number': 'Please enter your waybill number.',
      'enter_waybill_number': 'Enter Waybill Number.',
      'search': 'Search',
      'reset': 'Reset',
      'print_all': 'Print All',
      'ship_date': 'Ship Date',
      'weight': 'Weight',
      'product_type': 'Product Type',
      'package_num': 'No. of labels',
      'delivery_name': 'Consignee Name',
      'pieces': 'Pieces',
      'api_failed_message': 'Failed Message',
      'status': 'Status',
      'system_status': 'LME System Status',
      'order_status': 'Order Status',
      'tracking_status': 'Tracking Status',
      'active': 'Active',
      'in_active': 'InActive',
      'operation': 'Operation',
      'print_selected_orders': 'Print Selected Orders',
      'print_batch_orders': 'Print Batch Orders',
      'please_select_batch': 'Please select a batch ID to print the label',
      'please_select_order': 'Please select an order ID to print the label',
      'courier_name': 'Courier Name',
      'email': 'Email',
      'company': 'Company Name',
      'address': 'Address',
      'address1': 'Address1',
      'address2': 'Address2',
      'city': 'City',
      'postal_code': 'Postal Code',
      'state': 'State',
      'country': 'Country',
      'country_code': 'Country Code',
      'shipment_content': 'Shipment Description',
      'phone': 'Phone',
      'district': 'District',
      'battery': 'Battery',
      'insurance_value': 'Insurance Value',
      'shipping_code': 'Courier Shipping Method Code',
      'incoterm': 'Incoterm',
      'weight_unit': 'Weight Unit',
      'height': 'Height',
      'width': 'Width',
      'length': 'Length',
      'dimension_uom': 'Dimension UOM',
      'remark': 'Remark',
      'courier_reference_id': 'Courier Reference ID',
      'number_of_pieces': 'Number Of Pieces',
      'declared_currency': 'Declared Currency',
      'declared_value': 'Declared Value',
      'extra_instruction': 'Extra Instruction',
      'order_upload_date': 'Order Upload Date',
      'created_date': 'Created Date',
      'created_at': 'Create At',
      'not_allow_edit': 'You are not allowed to edit this order, please check the order status',
      'update_pending_success': 'Update Pending Delivery Label Success',
      'create_pending_success': 'Create Pending Delivery Label Success',
      'download_ready_to_ship_order': 'Download Ready to Ship Orders',
      'pick_up_shipment': 'Set Shipments to - Pick Up',
      'download_below_order': 'Download Shipments - All Below',
      'download_not_delivered_order': 'Download Shipments - Not Delivered'
    },
    'label_detail': {
      'line_no': 'Line No',
      'sku': 'SKU',
      'product_name': 'Product Name',
      'description_export': 'Description - Export',
      'description_import': 'Description - Import',
      'country_of_origin': 'Country Of Origin',
      'quantity': 'Quantity',
      'item_declared_value': 'Item Declared Value',
      'hscode': 'HS Code',
      'hsdescription': 'HS Code Description',
      'created_at': 'Create At'
    },
    'warning': {
      'please_input_all_the_required_information': 'Please input all the required information!',
    }
  },
  'marketplace': {
    'marketplace_name': 'Marketplace Name',
    'marketplace_store': 'Marketplace Store',
    'marketplace_faq': 'Marketplace FAQ',
    'marketplace_rma_product': 'Marketplace RMA Product',
    'marketplace_courier': 'Marketplace Courier',
    'order': {
      'filter_option': 'Filter Option',
      'created_order_date': 'Created Order Date',
      'platform_order_id': 'Platform ID',
      'please_enter_platform_order_id': 'Please enter your platform order id',
      'enter_platform_order_id': 'Enter Platform ID',
      'please_enter_tracking_no': 'Please enter your tracking no.',
      'enter_tracking_no': 'Enter Tracking No..',
      'platform': 'Platform',
      'please_select_platform': 'Please select your platform',
      'search': 'Search',
      'reset': 'Reset',
      'sync_update': 'Sync & Update Order',
      'purchase_date': 'Purchase Date',
      'total_amount': 'Total Amount',
      'total_commission': 'Total Commission',
      'status': 'Status',
      'tracking_status':'Tracking Status',
      'updated_at': 'Updated At',
      'active': 'Active',
      'in_active': 'InActive',
      'operation': 'Operation',
      'currency': 'Currency',
      'order_status': 'Order Status',
      'platform_order_status': 'Platform Order Status',
      'queue_job_status': 'Queue Job Status',
      'created_date': 'Created Date',
      'please_select_order': 'Please select an order ID to print the label',
      'courier_name': 'Courier Name',
      'email': 'Email',
      'company': 'Company Name',
      'battery': 'Battery',
      'bill_name': 'Bill Name',
      'bill_phone': 'Bill Phones Number',
      'bill_postal_code': 'Bill Postal Code',
      'bill_country': 'Bill Country',
      'bill_city': 'Bill City',
      'bill_district': 'Bill District',
      'bill_address': 'Bill Address',
      'shipping_name': 'Shipping Name',
      'shipping_phone': 'Shipping Phones Number',
      'shipping_postal_code': 'Shipping Postal Code',
      'shipping_country': 'Shipping Country',
      'shipping_city': 'Shipping City',
      'shipping_district': 'Shipping District',
      'shipping_address': 'Shipping Address',
      'created_at': 'Create At',
      'not_allow_edit': 'Not allow to edit this order, please check the order status',
      'update_pending_success': 'Update Pending Delivery Label Success',
      'create_pending_success': 'Create Pending Delivery Label Success',
      'platform_courier_name': 'Platform Courier Name',
      'platform_order_item_id': 'Platform Order Item Id',
      'tracking_no': 'Tracking No',
      'message': 'Message'
    },
    'order_detail': {
      'platform_order_id': 'Platform Order Id',
      'order_item_id': 'Order Item Id',
      'title': 'Title',
      'quantity_ordered': 'Quantity Ordered',
      'shipping_type': 'Shipping Type',
      'item_price': 'Item Price',
      'imei_code': 'IMEI Code',
      'shipping_price': 'Shipping Price',
      'total_commission': 'Total Commission',
      'tracking_no': 'Tracking No',
      'status': 'Status',
      'created_at': 'Create At'
    },
    'order_risk': {
      'platform_order_id': 'Platform Order Id',
      'platform': 'Platform',
      'platform_risk_id': 'Platform Risk Id',
      'checkout_id': 'Checkout Id',
      'recommendation': 'Recommendation',
      'display': 'Display',
      'cause_cancel': 'Cause Cancel',
      'message': 'Message',
      'merchant_message': 'Merchant Message'
    },
    'contact': {
      'message_type': 'Message Type',
      'contact_user_message': 'Contact User Message'
    },
    'store': {
      'store_account': 'Store Account',
      'store_name': 'Store Name',
      'store_user_id': 'Store User ID',
      'store_token': 'Store Token',
      'store_email': 'Store Email',
      'store_currency': 'Store Currency',
      'service_url': 'Service Url',
      'time_schedule': 'Time Schedule',
      'debug': 'Debug',
      'remark': 'Remark',
      'status': 'Status',
      'operation': 'Operation',
      'created_at': 'Create At',
      'active': 'Active',
      'in_active': 'InActive',
      'submit': 'Submit',
      'update': 'Update',
      'success_message': 'Update Marketplace Store Success!'
    },
    'rma_product': {
      'platform': 'Platform',
      'platform_order_id': 'Platform Order Id',
      'order_item_id': 'Order Item ID',
      'imei_code': 'Imei Code',
      'product_name': 'Product Name',
      'tracking_number': 'Tracking Number',
      'return_requested_at': 'Return Requested At',
      'type': 'Type',
      'qty': 'Qty',
      'conditions': 'Conditions',
      'cost': 'Cost',
      'selling_price': 'Platform Selling Price',
      'deal_price': 'Deal Price',
      'sold_date': 'Re-Sold Date',
      'status': 'Status',
      'operation': 'Operation',
      'created_at': 'Create At',
      'updated_at': 'Updated At',
      'active': 'Active',
      'in_active': 'InActive',
      'submit': 'Submit',
      'update': 'Update',
      'filter_option': 'Filter Option',
      'please_enter_platform_order_id': 'Please enter platform order id',
      'please_enter_document_no': 'Please enter your delivery No.',
      'please_enter_tracking_no': 'Please enter your Tracking No.',
      'enter_platform_order_id': 'Enter Platform Order Id',
      'please_select_platform': 'Please select your platform',
      'please_enter_imei_code': 'Please enter imei code',
      'please_enter_product_name': 'Please enter Product Name',
      'search': 'Search',
      'reset': 'Reset',
      'document_no': 'Delivery No.',
      'manual_create': 'Manual Create',
      'remark': "Remark",
      'settled': {
        'title': 'Are you sure?',
        'text': 'You will not be able to revert this!',
        'confirm_button': 'Yes, settled it!'
      },
      'success_message': 'Create Marketplace RMA Product Success!',
      'return_tracking_number': 'Return Tracking No.',
      'warehouse_received_at': 'Warehouse Received At',
      'book_in': 'Book In',
      'book_in_rma_product':'Book In Item',
      'add_to_rma_product':'Select Item'
    },
    'faq': {
      'title': 'Title',
      'content': 'Content',
      'platform': 'Platform',
      'status': 'Status',
      'operation': 'Operation',
      'created_at': 'Create At',
      'active': 'Active',
      'in_active': 'InActive',
      'submit': 'Submit',
      'update': 'Update',
      'created_date': 'Created Date',
      'filter_option': 'Filter Option',
      'please_enter_title': 'Please enter title',
      'enter_title': 'Enter Title',
      'please_select_platform': 'Please select your platform',
      'search': 'Search',
      'reset': 'Reset',
      'success_message': 'Update Marketplace FAQ Success!'
    }
  },
  'track': {
    'delivery_order_no': 'delivery Order No',
    'waybill_number': 'Waybill Number',
    'route_description': 'Route Description',
    'route_date': 'Route Date',
    'route_status': 'Route Status',
    'updated_by': 'Updated By',
    'created_by': 'Created By',
    'collect': 'Collect',
    'signed': 'Signed',
    'transporting': 'Transporting',
    'operation': 'Operation'
  },
  'shipper': {
    'courier_name': 'Courier Name',
    'shipper_account': 'Shipper Account',
    'billing_account': 'Billing Account',
    'duty_account': 'Duty Account',
    'shipper_id': 'Shipper ID',
    'shipper_name': 'Shipper Name',
    'registered_account': 'Registered Account',
    'address_line_1': 'Address Line 1',
    'address_line_2': 'Address Line 2',
    'city': 'City',
    'postal_code': 'Postal Code',
    'division': 'Division',
    'division_code': 'Division Code',
    'country_code': 'Country Code',
    'country_name': 'Country Name',
    'contact_person': 'Contact Person Name',
    'contact_phone': 'Contact Phone',
    'status': 'Status',
    'operation': 'Operation',
    'active': 'Active',
    'in_active': 'InActive',
    'submit': 'Submit',
    'update': 'Update',
    'success_message': 'Update Shipper Account Success!'
  },
  'supplier': {
    'primary_name': 'Primary Name',
    'secondary_name': 'Secondary Name',
    'address': 'Address',
    'postal_address': 'Postal Address',
    'payee_bank_name': 'Payee Bank Name',
    'payee_bank_swiftbic': 'Payee Bank Swiftbic',
    'payee_bank_account_name': 'Payee Bank Account Name',
    'email': 'Email',
    'tel': 'Tel',
    'fax': 'Fax',
    'active': 'Active',
    'in_active': 'In Active',
    'mobile': 'Mobile',
    'br': 'BR',
    'contact_person': 'Contact Person',
    'status': 'Status',
    'operation': 'Operation',
    'success_message': 'Update supplier successful',
    'update': 'Update',
    'invoice': {
      'label': {
        'search': 'Search',
        'reset': 'Reset',
        'invoice_date': 'Invoice Date',
        'supplier_name': 'Supplier Name',
        'filter_option': 'Filter Option',
        'invoice_no': 'Invoice No.',
        'please_enter_invoice_no': 'Please enter your invoice no.',
        'enter_invoice_no': 'Enter Invoice No.',
        'tracking_no': 'Tracking No.',
        'please_enter_tracking_no': 'Please enter your tracking No.',
        'enter_tracking_no': 'Enter Tracking No.',
        'batch_id': 'Batch Id',
        'supplier': 'Supplier',
        'description': 'Description',
        'date': 'Date',
        'due_date': 'Due Date',
        'total_amount': 'Total Amount',
        'remark': 'Remark',
        'status': 'Status',
        'operation': 'Operation',
        'created_at': 'Create At',
        'updated_at': 'Updated At',
      },
      'label_detail': {
        'batch_id': 'Batch Id',
        'tracking_no': 'Tracking No.',
        'shipment_date': 'Shipment Date',
        'product': 'Product',
        'shipment_weight': 'Weight',
        'shipment_weight_unit': 'Weight Unit',
        'operation_fee': 'Operation Fee',
        'kilogram_fee': 'Kilogram Fee',
        'peak_season_surcharge': 'Peak Season Surcharge',
        'discount': 'Discount',
        'pickup_fee': 'Pickup Fee',
        'returned_fee': 'Returned Fee',
        'total_amount': 'Total Amount',
        'remark': 'Remark',
        'amount': 'Amount',
        'status': 'Status',
        'shipment_status': 'Shipment Status',
      }
    },
  },
  'courier': {
    'courier_name': 'Courier Name',
    'incoterm': 'Incoterm',
    'fuel_surcharge': 'Fuel Surcharge (%)',
    'currency': 'Currency',
    'lead_time': 'Lead Time',
    'status': 'Status'
  },
  'note': {
    'label': {
      'creator': 'Creator',
      'note': 'Note',
      'created_at': 'Created At',
      'operation': 'Operation'
    },
    'update_success': 'Update Message Success'
  },
  'comparison_tool': {
    'destination_country': 'Destination Country',
    'destination_state': 'Destination State',
    'warehouse': 'Warehouse',
    'postal_code': 'Postal Code',
    'weight': 'Weight (kg)',
    'service_type': 'Service Type',
    'battery_type': 'Battery Type',
    'incoterm': 'Incoterm',
    'max_dimension': 'Max Dimension'
  },
  'login': {
    'sign_in_account': 'Sign In to your account',
    'login': 'Login',
    'email': 'Email',
    'password': 'Password',
    'forgot_password': 'Forgot password?',
    'register_now': 'Register Now!',
    'sign_up': 'Sign up'
  },
  'error': {
    'search': 'Search',
    'oops_message': 'Oops! You are lost.',
    'page_not_found': 'The page you are looking for was not found.',
    'houston_problem': 'Houston, we have a problem!',
    'what_looking_for': 'What are you looking for?',
    'temporarily_unavailable': 'The page you are looking for is temporarily unavailable.'
  },
  'operation': {
    'delete': {
      'title': 'Are you sure?',
      'text': 'You will not be able to revert this!',
      'confirm_button': 'Yes, delete it!'
    },
    'rma_lost': {
      'title': 'Are you sure?',
      'text': 'You will not be able to revert this!',
      'confirm_button': 'Yes, Mark As Lost!'
    },
    'claim': {
      'title': 'Are you sure?',
      'text': 'You will claim the invoice item!',
      'confirm_button': 'Yes, claim it!'
    }
  },
  'dashboard': {
    'marketplace': {
      'marketplace_order': 'Marketplace Orders',
      'order_request_date': 'Requested At',
      'total': 'Total',
      'total_amounts': 'Total Amounts',
      'currency': 'Currency'
    },
    'rma': {
      'warning_return_request_title': 'No Received RMA After 30 Days',
      'platform': 'Platform',
      'document_no': 'Document No.',
      'platform_order_id': 'Platform Order ID',
      'product_name': 'Product Name',
      'imei_code': 'IMEI Code',
      'updated_at': 'Updated At',
      'created_at': 'Created At',
      'selling_price': 'Selling Price'
    },
    'currency': {
      'currency_rate': 'Currency',
      'from': 'From',
      'to': 'To',
      'rate': 'Rate',
      'updated_at': 'Updated At'
    }
  }
}
